<template>
<div class="item-action">
  <button @click="handleClick">
    <div class="item-action-icon"><slot /></div>
    <p class="item-action-label">{{buttonLabel}}</p>
  </button>
</div>
</template>

<script>
export default {
  name: 'ActionButton',
  props: {
    buttonLabel: {
      type: String,
      required: true
    }
  },
  methods: {
    handleClick() {
      this.$emit('clicked');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/sass/_config.scss';

.item-action {
  padding: 5px 20px;
  display: flex;
  justify-content: center;
  align-items: baseline;

  &.disabled {
    cursor: auto;
  }
}

.item-action-icon {
  margin: auto;
  width: 30px;
  height: 30px;
  padding: 0;

  svg {
    width: 100%;
    height: 100%;
  }
}

button {
  padding: 0;
  min-width: 50px;
  text-align: center;
  color: $accent-color;
  background: none;
  border: none;
  font-weight: 500;
  cursor: pointer;
  transition: color .3s;

  &:hover,
  &:hover .item-action-label {
    color: lighten($accent-color, 10%);
  }

  .fa,
  .fas,
  .far {
    font-size: 24px;
  }
}

.item-action-label {
  color: $dark-grey;
  font-size: 12px;
  transition: color .3s;
}
</style>

